$(document).ready(function(){	
	$('.tmp_menudropdown_v1 > ul > li, .tmp_menudropdown_home > ul > li').hoverIntent(function(){
	    const el = $(this);
        el.find("ul").animate({
			height: "show"
		}, {
			duration: 200,
			specialEasing: { 
				//height: 'easeOutBack'
			},complete: function () {
                el.find('.dropdownaktiv').css('opacity', 1);
            }
		});
	},function(){
        const el = $(this);
        el.find('.dropdownaktiv').css('opacity', 0);
        el.find("ul").animate({
			height: "hide"
		}, {
			duration: 200,
			specialEasing: { 
				//height: 'easeInBack'
			}
		});
	});	 
	
	const menu_dropdown_li = $('.tmp_menudropdown_v1 > ul > li').length;
	$('.tmp_menudropdown_v1 > ul > li').each(function(i){
		if ( i >= menu_dropdown_li / 2){
			//$(this).addClass("submenu-right");
		} 
	});
	
});
